export default __webpack_public_path__ + "static/media/corporate7.bcd8897e.jpg";